/* Phone-menu controller: uses the existing drawer markup and menu links. */
(() => {
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return

  const closeDrawer = (details, summary) => {
    details.removeAttribute('open')
    details.classList.remove('menu-opening')
    summary.setAttribute('aria-expanded', 'false')
    document.body.classList.remove('overflow-hidden-tablet')
  }

  const openDrawer = (details, summary) => {
    const header = document.querySelector('.shopify-section-header')
    if (header) document.documentElement.style.setProperty('--header-bottom-position', `${Math.round(header.getBoundingClientRect().bottom)}px`)
    details.setAttribute('open', '')
    details.classList.add('menu-opening')
    summary.setAttribute('aria-expanded', 'true')
    document.body.classList.add('overflow-hidden-tablet')
  }

  const attachController = () => {
    document.querySelectorAll('header-drawer > details.menu-drawer-container').forEach((details) => {
      if (details.dataset.mobileDrawerFallbackBound === 'true') return
      const summary = details.querySelector(':scope > summary')
      if (!summary) return
      details.dataset.mobileDrawerFallbackBound = 'true'
      summary.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()
        if (details.open) closeDrawer(details, summary)
        else openDrawer(details, summary)
      }, true)
    })
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachController)
  else attachController()
  document.addEventListener('shopify:section:load', attachController)
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return
    document.querySelectorAll('header-drawer > details.menu-drawer-container[open]').forEach((details) => closeDrawer(details, details.querySelector(':scope > summary')))
  })
})()
